"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Drivers = function () {
  function Drivers($q, API) {
    _classCallCheck(this, Drivers);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Drivers, [{
    key: "getDrivers",
    value: function getDrivers(groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var deferred = this.$q.defer();
      var url = "v1/drivers";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (drivers) {
        //console.log("drivers: ", drivers);
        deferred.resolve(drivers);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Drivers;
}();

exports.default = Drivers;


Drivers.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.drivers.js